import React from "react";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { BoxSpg } from "@duosoftbg/nacid-components";

const BoxedHeaderWrapper = styled(BoxSpg)`
  background: #eee;
  margin-top: 15px;
  padding: 7px 7px 7px 10px;
  border-radius: 4px;
  color: #000000a6;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & h4 {
    font-size: 14px;
    line-height: 1.2;
    margin: 0;
  }
`;

const PreviousSubmittedAppFormSection = ({ children, label, ml = 4 }) => {
  const { t } = useTranslation();

  return (
    <>
      <BoxedHeaderWrapper>
        <Typography variant={"h4"}>{t(label)}</Typography>
      </BoxedHeaderWrapper>
      <BoxSpg ml={ml}>{children}</BoxSpg>
    </>
  );
};

export default PreviousSubmittedAppFormSection;
